// extracted by mini-css-extract-plugin
export default {"component":"a3uC9"};